import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.GATSBY_SUPABASE_URL
const supabaseAnonKey = process.env.GATSBY_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Single Supabase client instance to avoid GoTrueClient warnings
let _supabaseInstance = null

export const getSupabaseClient = () => {
  if (!_supabaseInstance) {
    _supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  }
  return _supabaseInstance
}

// Export the singleton instance
export const supabase = getSupabaseClient()

// Export for backwards compatibility
export default supabase
